import { ModelRow, Navigation, StringUtil } from "@mcleod/core";
import { Label, Panel, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutManageCarrierCapacity } from "./autogen/AutogenLayoutManageCarrierCapacity";

export class ManageCarrierCapacity extends AutogenLayoutManageCarrierCapacity {
    public carrierId: string;

    tableAddedTractorsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target;
        const modelRow = tableRow.data as ModelRow;

        this.setupStatus(tableRow, modelRow);
    }

    buttonCarrierCapacityOnClick() {
        const selected = this.tableAddedTractors.selectedRows;
        const selectedDetailCsv = selected.map(row => row.data.getString("id")).join(",");
        
        const path = `lme/powerbroker/CarrierCapacity?carrier=${this.carrierId}`
            + `${!StringUtil.isEmptyString(selectedDetailCsv) ? "&managed=" + selectedDetailCsv : ""}`;
        Navigation.navigateTo(path, { newTab: true, height: 1400, width: 1850, windowDecorators: false });
    }

    setupStatus(tableRow: TableRow, modelRow: ModelRow) {
        const panel = tableRow.findComponentById("panelStatus") as Panel;
        const labelStatus = panel?.findComponentById("labelStatus") as Label;
        const status = modelRow.getString("status", "");
        if (panel != null) {
            if (status != null) {
                const bgColor = tableRow.data.get("status_color");
                if (bgColor === "#ffffff") {
                    panel.borderWidth = 1;
                    panel.borderColor = "primary";
                    panel.backgroundColor = bgColor;
                    labelStatus.color = "primary";
                } else {
                    panel.borderWidth = 0;
                    panel.backgroundColor = bgColor;
                    labelStatus.color = "default.reverse";
                }
                labelStatus.text = status;

            } else {
                labelStatus.color = "default";
                labelStatus.text = "--";
                panel.borderWidth = 1;
                panel.borderColor = "subtle";
            }
        }
    }

    buttonAvailableTractorsOnClick() {
        Navigation.navigateTo(`lme/dispatch/AvailableTractorList?carrierId=${this.carrierId}`, {newTab: true});
    }
}
